import Select from './select';
import SelectOption from './option';
import SelectOptGroup from './opt-group';
var DefaultSelect = Select;
DefaultSelect.Option = SelectOption;
DefaultSelect.OptGroup = SelectOptGroup;
export default DefaultSelect;
//# sourceMappingURL=index.js.map